import { AcademicWorkloadAllocationsWithCalculations } from '#server/models';
import { formatHours } from '@/lib/utils';
import { SearchFilter } from '@/store/types';
import { Note } from './Note';

interface AcademicWorkloadPanelProps {
  selectedSchool: SearchFilter;
  allocationsWithCalculatedHours: AcademicWorkloadAllocationsWithCalculations;
}
export const AcademicWorkloadPanel = ({
  selectedSchool,
  allocationsWithCalculatedHours,
}: AcademicWorkloadPanelProps) => {
  const selectedSchoolName = selectedSchool.label;
  const selectedSchoolId = selectedSchool.value;

  return (
    <div className="flex h-full w-[240px] flex-col items-start justify-between bg-primary-website-background-colour py-8 pl-[35px] pr-3">
      <div className="flex flex-shrink-0 flex-col items-start gap-5 text-base leading-6 text-primary-black-90">
        <div className="text-sh3 font-bold">Allocate staff workload</div>
        <span className="mb-[60px] mt-8 text-b3 font-semibold text-secondary-grey-02">{selectedSchoolName}</span>
        <div className="flex flex-col gap-y-3">
          <div className="text-b3 font-bold text-primary-black-90">
            {allocationsWithCalculatedHours?.lastName}, {allocationsWithCalculatedHours?.firstName}
          </div>
          <div className="grid grid-cols-[max-content_1fr] gap-x-2 gap-y-1 text-xs text-secondary-grey-01">
            <div className="font-bold">Curtin ID</div>
            <div className="font-normal">{allocationsWithCalculatedHours.curtinId}</div>
            <div className="font-bold">Work function</div>
            <div className="font-normal">{allocationsWithCalculatedHours.workFunctionAbbr}</div>
            <div className="font-bold">Assigned hours</div>
            <div className="font-normal">
              {formatHours(allocationsWithCalculatedHours.totalAssignedHours, false, 2)} of{' '}
              {formatHours(allocationsWithCalculatedHours.availableHours, false, 2)}
            </div>
            <div className="font-bold">Workload allocated</div>
            <div className="font-normal">
              {formatHours(
                (allocationsWithCalculatedHours.totalAssignedHours / allocationsWithCalculatedHours.availableHours) *
                  100,
                false,
                2,
              )}
              %
            </div>
            <div className="font-bold">FTE</div>
            <div className="font-normal">{allocationsWithCalculatedHours.fte}</div>
            <div className="font-bold">AQF level category</div>
            <div className="font-normal">
              {allocationsWithCalculatedHours.aqf === '' ? 'N/A' : allocationsWithCalculatedHours.aqf}
            </div>
          </div>
        </div>
      </div>

      <Note
        schoolId={selectedSchoolId}
        academicId={allocationsWithCalculatedHours.id}
        academicWorkloadNote={allocationsWithCalculatedHours.note}
      />
    </div>
  );
};
